import TemplateView from '../../TemplateView'

export default class CopySettingsItem extends TemplateView {
    constructor({
        id = null,
        text = '',
    }) {
        super()
        this.id = id
        this.text = text
    }

    templateHtml() {
        return '<label class="copySettingsItem">' +
               '   <input type="checkbox" id="<%=id%>" class="input" checked/>' +
               '   <span class="text"><%-text%></span>' +
               '</label>'
    }

    isChecked() {
        return this.find('input').is(':checked')
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/components/CopySettingsItem.js